import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { buyerPhonePayload } from '~/components/ContactForm/ContactForm.utils';
import { useInvalidateContactIdentity, useUpdateContactSummary } from '~/hooks/reactQuery/queries/useContactSummaryMutations';
import { useStoreActions } from '~/store/store-context';
import { nativeUserIdOf } from '../../ContactsDashboardRow.utils';
import { normalizedIdentity } from '../EditContactIdentityModal.utils';
import { useEmailChangeGuard } from './useEmailChangeGuard';
export const useSaveContactIdentity = (guardTestIds)=>{
    const { api } = useStoreActions();
    const { updateContactSummary } = useUpdateContactSummary();
    const invalidateContactIdentity = useInvalidateContactIdentity();
    const guardEmailChange = useEmailChangeGuard(guardTestIds);
    const saveNativeIdentity = async (userId, contact, values)=>{
        const identity = normalizedIdentity(values);
        if (identity.email !== contact.email.trim()) {
            await api.user.updateBuyerEmailV2(userId, identity.email);
        }
        await api.user.updateBuyer(userId, _object_spread_props(_object_spread({
            name: {
                first: identity.firstName,
                last: identity.lastName
            }
        }, buyerPhonePayload(values.phone)), {
            customerBusinessId: undefined
        }));
        invalidateContactIdentity();
    };
    return async (contact, values)=>{
        if (await guardEmailChange(contact, values.email) === 'cancel') return;
        const userId = nativeUserIdOf(contact);
        if (userId != null) return saveNativeIdentity(userId, contact, values);
        await updateContactSummary(_object_spread({
            contactId: contact.contactId
        }, normalizedIdentity(values)));
    };
};
